import { isDemoMode } from "../demo/core";

/** In demo mode only local images (bundle, blob:, data:) may be fetched — never a remote host. */
function isLocalImageUrl(url: string): boolean {
  if (url.startsWith("blob:") || url.startsWith("data:")) return true;
  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    return false;
  }
}

/** Fetch a remote image as a data URL for jsPDF rasterization. */
export async function fetchImageAsDataUrl(url: string): Promise<string | null> {
  if (isDemoMode() && !isLocalImageUrl(url)) return null;
  try {
    const resp = await fetch(url, { mode: "cors" });
    if (!resp.ok) return null;
    const blob = await resp.blob();
    return await new Promise<string | null>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve(typeof reader.result === "string" ? reader.result : null);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}
